import React, { useEffect, useRef, useState } from "react";
import MessageInput from "./MessageInput";
import { deepBlue } from "Common/commaon";
import SimpleBar from "simplebar-react";
import avatar2 from "assets/images/users/avatar-2.jpg";
import { Button, Card, Row, Col, Form, Dropdown } from "react-bootstrap";

const ChatWindow = ({ selectedConversation, identity, onDeleteConversation }: any) => {
  const [messages, setMessages] = useState<any[]>([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const [messageInput, setMessageInput] = useState("");

  // 📌 Load messages when a conversation is selected
  useEffect(() => {
    if (!selectedConversation) return;

    const loadMessages = async () => {
      try {
        const messagePaginator = await selectedConversation.getMessages();
        setMessages(messagePaginator.items);
      } catch (error) {
        console.error("Error loading messages:", error);
      }
    };

    loadMessages();

    // Listen for new messages in real-time
    const messageAddedHandler = (message: any) => {
      setMessages((prevMessages) => [...prevMessages, message]);
    };

    selectedConversation.on("messageAdded", messageAddedHandler);

    return () => {
      selectedConversation.removeListener("messageAdded", messageAddedHandler);
    };
  }, [selectedConversation]);

  // 📌 Scroll to the latest message automatically
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const sendMessage = async () => {

    if (selectedConversation && messageInput.trim()) {
      await selectedConversation.sendMessage(messageInput);
      setMessageInput("");
   
    }
  };

  const handleDeleteConversation = async () => {
    if (selectedConversation) {
      await selectedConversation.delete();
      onDeleteConversation(selectedConversation.sid);
      setMenuOpen(false);
    }
  };

  // 📌 Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-2/3 ml-5 bg-white rounded-md flex flex-col overflow-hidden">
      {selectedConversation ? (
        <>
          {/* Chat Header */}
          <div className="flex justify-between items-center p-3 border-b relative">
            <div className="flex items-center">
              <div className="bg-gray-400 h-[50px] w-[50px] rounded-full"></div>
              <div className="ml-5">
                <div className="font-semibold">{selectedConversation.friendlyName}</div>
                <div className="text-gray-500">Online</div>
              </div>
            </div>

            {/* Three-dot menu button */}
            <div className="relative" ref={menuRef}>
              {identity === selectedConversation.createdBy && (
                <i
                  className="bi bi-three-dots-vertical text-gray-500 text-[20px] cursor-pointer"
                  onClick={() => setMenuOpen(!menuOpen)}
                ></i>
              )}

              {/* Dropdown Menu */}
              {menuOpen && (
                <div className="absolute right-0 mt-2 w-[140px] rounded-md shadow-lg z-10">
                  <button
                    style={{ backgroundColor: deepBlue }}
                    className="w-full justify-start flex items-center text-left px-3 py-2 text-white rounded-md hover:bg-gray-100"
                    onClick={handleDeleteConversation}
                  >
                    <i className="bi bi-trash3-fill text-white text-[15px] mr-2 flex items-center cursor-pointer"></i>
                    <div>Delete Chat</div>
                  </button>
                </div>
              )}
            </div>
          </div>
          <SimpleBar style={{ height: window.innerHeight-420}}>
                                <div className="chat-conversation p-3" id="chat-conversation" >
          {/* Chat Messages */}
          <ul className="list-unstyled chat-conversation-list chat-sm">
    {messages.map((msg) => (
        <li key={msg.sid} className={`chat-list ${msg.author === identity ? "right" : "left"}`}>
            <div className="conversation-list">
                {msg.author !== identity && (
                    <div className="chat-avatar">
                        <img src={avatar2} alt="User Avatar" />
                    </div>
                )}
                <div className="user-chat-content">
                    <div className="ctext-wrap">
                        <div className="ctext-wrap-content">
                            <p className="mb-0 ctext-content">{msg.body}</p>
                        </div>
                    </div>
                    <div className="conversation-name">
                        <small className="text-muted time">
                        {new Date(msg.dateCreated).toLocaleTimeString("en-US", {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
})}
                        </small>
                        <span className="text-success check-message-icon">
                            <i className="ri-check-double-line align-bottom"></i>
                        </span>
                    </div>
                </div>
            </div>
        </li>
    ))}
</ul>
</div>
</SimpleBar>

          {/* Message Input */}
          <div className="border-top border-top-dashed">
                            <Row className="g-2 mx-3 mt-2 mb-3">
                                <Col className="col">
                                    <div className="position-relative">
                                    <Form.Control
    type="text"
    className="border-light bg-light"
    placeholder="Enter Message..."
    value={messageInput}
    onChange={(e) => setMessageInput(e.target.value)}
    // onKeyDown={(e) => e.key === "Enter" && sendMessage(e.target.value)} 
/>
                                    </div>
                                </Col>
                                <Col className="col-auto">
                                    <Button onClick={sendMessage} variant="secondary" type="submit"><i className="mdi mdi-send"></i></Button>
                                </Col>
                            </Row>
                        </div>
          {/* <MessageInput sendMessage={sendMessage} /> */}
        </>
      ) : (
        <div className="flex items-center justify-center flex-1 text-gray-500">
          Select a conversation to start chatting
        </div>
      )}
    </div>
  );
};

export default ChatWindow;
